export default "__VITE_ASSET__D2focPtm__"